import React from 'react';
import Router from './routes';
import './global.scss';

export default function App() {
  return (
    <div>
      <Router />
    </div>
  );
}
